<ng-container class="" *transloco="let t; read: 'ime.components.help'">
  <div class="p-2" *ngIf="help$ | async as help; else noHelp">
    <div class="d-flex align-items-center bb-1 border-default mb-2">
      <h4>{{help.Title}}</h4>
      <button type="button" class="btn btn-sm btn-outline-primary ms-auto mb-1" (click)="navigate(help)">
        {{t('Open')}}
      </button>
      <button type="button" class="btn-close ms-2 mb-1" aria-label="Close" (click)="close()">
      </button>
    </div>
    <div class="alert alert-warning d-flex align-items-center" role="alert" *ngIf="help.NeedsUpdate">
      <svg viewBox="0 0 8 8" class="icon me-2" inlineSVG="#exclamation-circle">
      </svg>
      {{t('This help topic may be outdated')}}
      <button type="button" class="btn btn-outline-warning ms-2" (click)="getBaseVersion(help.Key)">
        {{t('View base version')}}
      </button>
    </div>
    <app-help-container [value]="help.Value"
                        [isLoading]="isLoading()"
                        (onCreate)="navigate(help, true)"></app-help-container>
  </div>
  <ng-template #noHelp>
    <div class="d-flex align-items-center bb-1 border-default mb-2">
      <button type="button" class="btn-close ms-auto my-1" aria-label="Close" (click)="close()">
      </button>
    </div>
  </ng-template>
</ng-container>
